import { render, staticRenderFns } from "./ModalAjudaChatbot.vue?vue&type=template&id=5beab073&scoped=true&"
import script from "./ModalAjudaChatbot.vue?vue&type=script&lang=js&"
export * from "./ModalAjudaChatbot.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjudaChatbot.vue?vue&type=style&index=0&id=5beab073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beab073",
  null
  
)

export default component.exports